export default "__VITE_ASSET__cVSkjRr3__"